import React, { useContext } from 'react'
import FormalityArchiveDownload from '../FormalityArchiveDownload'
import MergeableMenu from './MergeableMenu'

import { CurrentLegalFormalityContext } from 'contexts/LegalFormalityContext'
import { LegalFormalityDocumentContext } from 'contexts/LegalFormalityDocumentContext'

import { FormalityActionsWrapper } from '../styles'
import { AbilityContext } from '../../../../../contexts/abilityContext'

const Actions = () => {
  const { selectedDocumentListItem } = useContext(LegalFormalityDocumentContext)
  const { legalFormality } = useContext(CurrentLegalFormalityContext)
  const ability: any = useContext(AbilityContext)
  const formalistOnly = ability.can('update', 'LegalFormality')

  if (!formalistOnly) return false

  return (
    <FormalityActionsWrapper>
      {selectedDocumentListItem.mergeable && <MergeableMenu />}
      {legalFormality.status == 'signature_signed' && (
        <FormalityArchiveDownload />
      )}
    </FormalityActionsWrapper>
  )
}
export default Actions
